import fetchAvailablePackages from './fetch-available-packages';
import fetchEcommercePackages from './fetch-ecommerce-packages';

export default {
  fetchAvailablePackages,
  fetchEcommercePackages,
};
